import { z } from 'zod';

// Schema for login form validation
export const loginSchema = z.object({
  cpf: z
    .string()
    .min(1, 'CPF é obrigatório')
    .refine((cpf) => {
      const cleanCpf = cpf.replace(/[.-]/g, '');
      return cleanCpf.length === 11 && /^\d+$/.test(cleanCpf);
    }, 'CPF deve ter 11 dígitos')
    .transform((cpf) => {
      // Format CPF as XXX.XXX.XXX-XX for API
      const cleanCpf = cpf.replace(/[.-]/g, '');
      return cleanCpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }),
  password: z
    .string()
    .min(1, 'Senha é obrigatória')
    .min(6, 'A senha deve ter pelo menos 6 caracteres'),
});

// Tipo derivado do schema de login
export type LoginFormData = z.infer<typeof loginSchema>;

